/*
 * @Description:
 * @Date: 2021-02-03 09:22:33
 */
const state = {
  info: {}
};
const mutations = {
  SET_INFO(state, data) {
    state.info = data;
  }
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
